import "./Msgbox.less";
import Images from "./Images";
import { createRoot, Root } from "react-dom/client";
import { observer } from "mobx-react";
import { FULLSCREEN_MOUNT } from "../pages/Main/Main";
import { CloseBtn } from "../component/CloseBtn/CloseBtn";

export enum MSG_TYPE{
    SUCCESS,
    INFO,
    ERROR
}

const foo = () => {}
let msgboxNode:Element | null = null;
let root: Root | null = null;

type MsgboxProps = {
    msg: string,
    type: MSG_TYPE,
    onOK: () => void,
    onCancel: () => void,
    onCancelText: string,
    onOkText: string,
    title?: string;
};

const closeMsgbox = (): void => {
    (document.getElementById(FULLSCREEN_MOUNT) as Element).removeChild(msgboxNode as Element);
    msgboxNode = null;
    root = null;
}

const Msgbox = observer((props:MsgboxProps):React.ReactElement => {
    const onOkClick = ():void => {
        closeMsgbox();
        props.onOK();
    };

    const onCancelClick = ():void => {
        closeMsgbox();
        props.onCancel();
    };

    return <div className="msgbox loading-anim-layer fullscreen-dialog-bg-color">
        <div className="msgbox-inner segment-color dialog-border">
            <CloseBtn right="0.07rem" top="0.07rem" width="0.1rem" height="0.1rem" onClick={closeMsgbox}></CloseBtn>
            <div style={{height:"0.16rem", display:"flex", justifyContent:"flex-start", alignItems:"center", columnGap:"0.09rem"}}>
                <img src={Images.exclamation}></img>
                <span style={{fontSize:"0.14rem"}}>{props.title || "提示"}</span>
            </div>
            <div className="msg-box-content no-scrollbar">
                <div style={{wordBreak:"break-all"}}>
                    {props.msg}
                </div>
            </div>
            <div className="msgbox-bottom">
                <div className="msgbox-cancel-btn segment-color" onClick={onCancelClick} style={{visibility:props.type == MSG_TYPE.INFO ? "visible" : "hidden"}}>
                    {props.onCancelText}
                </div>
                <div className="msgbox-confirm-btn" onClick={onOkClick}>{props.onOkText}</div>
            </div>
        </div>
    </div>;
});

export function msgbox(msg:string, type:MSG_TYPE, onOK?:() => void, onCancelText:string = "取消",onOkText:string = "确定", onCancel?:() => void,title?:string){
    if(!msgboxNode){
        msgboxNode = document.createElement("div");
        (document.getElementById(FULLSCREEN_MOUNT) as Element).appendChild(msgboxNode);
        root = createRoot(msgboxNode);
    }
    
    (root as Root).render(<Msgbox title={title} msg={msg} type={type} onOK={onOK || foo} onCancel={onCancel || foo} onCancelText={onCancelText} onOkText={onOkText}></Msgbox>);
}